module.exports = __webpack_public_path__ + "img/screen-2-step-1.c8e24222.png";